import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Drawer from 'rc-drawer';
import './drawer.css';
import {
	setNewReportDrawerState,
	setNewReportPropValue,
	removeNewReportImage,
	setNewReportAddressAttribute,
	setNewReportLocation,
	resetNewReport,
	sendNewReport,
	showNewReportGetAddressError
} from 'actions/NewReport';
import Map from './Component/Map';
import { Card, CardBody, CardHeader, Nav, NavItem, NavLink, TabContent, TabPane, Button, ListGroup, ListGroupItem } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import CardBox from 'components/CardBox/index';
import { injectIntl, intlShape } from 'react-intl';
import Dropzone from 'react-dropzone';
import Geocode from 'react-geocode';
import InputSize from 'constants/InputSize';
import swal from 'sweetalert';
import geolib from 'geolib';
import _ from 'lodash';
import ModulesContainer from 'containers/ModulesContainer';
import { strPreview, byteStr } from 'helperfunctions';
import Switch from 'react-switch';
import isIssue from 'helperfunctions/isIssue';

Geocode.setApiKey('AIzaSyBeDdj4XA0GQrGM16neBfzMSOPy49o0u5Q');
Geocode.enableDebug();

class NewReport extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: this.props.selectedTab || 'address', // 'address' oder 'map'
			oldVisibleStatus: this.props.newReport.visible,
			priority: null,
			deadline: null
		};
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.newReport.showFeedback && this.props.newReport.showFeedback)
			swal({
				title: this.props.intl.formatMessage({ id: 'newReport.send.success' }),
				text: this.props.intl.formatMessage({ id: 'newReport.send.feedback' }, { responsible: this.props.newReport.feedbackResponsible }),
				icon: 'success'
			});
	}

	handleFileDrop = file => {
		// Es können maximal 10 Dateien angehängt werden
		if (this.props.newReport.attachements.length > 9)
			return swal({
				title: this.props.intl.formatMessage({ id: 'newReport.attachements.error.title' }),
				text: this.props.intl.formatMessage({ id: 'newReport.attachements.error.text' }),
				dangerMode: true,
				icon: 'warning'
			});

		// Ausgewählte Datei auf Maximalgröße von 16 MB prüfen
		if (file.size > 16777215) {
			return swal({
				title: this.props.intl.formatMessage({ id: 'report.userComments.inputSizeError.title' }),
				text: this.props.intl.formatMessage({ id: 'report.userComments.inputSizeError.text' }),
				dangerMode: true,
				icon: 'warning'
			});
		}

		this.props.setNewReportPropValue({
			attachements: [...this.props.newReport.attachements, { file, fileName: file.name, fileType: file.type }]
		});
	};

	toggle = tab => {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	};

	getHouseNumber(address) {
		const streetNumber = address.find(element => element.types.find(type => type === 'street_number'));
		if (streetNumber) return streetNumber.long_name;
		return '';
	}

	getStreet(address) {
		const street = address.find(element => element.types.find(type => type === 'route'));
		if (street) return street.long_name;
		return '';
		// const streetNumber = address.find(element => element.types.find(type => type === 'street_number'));
		// if (street) return `${street.long_name}${streetNumber ? ` ${streetNumber.long_name}` : ''}`;
		// return '';
	}

	getZip(address) {
		const zip = address.find(element => element.types.find(type => type === 'postal_code'));
		if (zip) return zip.long_name;
		return '';
	}

	getCity(address) {
		const city = address.find(element => element.types.find(type => type === 'locality'));
		if (city) return city.long_name;
		return '';
	}

	getNeighborhood(address) {
		const neighborhood = address.find(element => element.types.find(type => type === 'sublocality'));
		if (neighborhood) return neighborhood.long_name;
		return '';
	}

	onSelectLocation = (lat, lng) => {
		// Adresse zu gegebenen Koordinaten bestimmen
		this.props.setNewReportLocation({ lat, lng });
		Geocode.fromLatLng(lat, lng).then(
			response => {
				const address = {
					zip: this.getZip(response.results[0].address_components),
					city: this.getCity(response.results[0].address_components),
					street: this.getStreet(response.results[0].address_components),
					houseNumber: this.getHouseNumber(response.results[0].address_components),
					neighborhood: this.getNeighborhood(response.results[0].address_components)
				};
				this.props.setNewReportAddressAttribute(address);
			},
			error => {
				console.error(error);
			}
		);
	};

	getCoordinatesToAddress = async address => {
		// Koordinaten zu gegebener Adresse bestimmen
		const res = await Geocode.fromAddress(`${address.street} ${address.houseNumber}, ${address.zip} ${address.city}`).then(
			response => {
				const { lat, lng } = response.results[0].geometry.location;
				return { lat, lng };
			},
			() => false
		);
		return res;
	};

	checkResponsiblity = latlng => {
		const polygons = this.props.responsibilityAreas.map(area => {
			return {
				...area,
				paths: area.paths.map(path =>
					path.map(coordinates => {
						return {
							latitude: coordinates[0],
							longitude: coordinates[1]
						};
					})
				)
			};
		});
		const insideArray = polygons.map(polygon => polygon.paths.map(path => geolib.isPointInside(latlng, path)));
		return _.compact(_.flatten(insideArray)).length > 0 ? true : false;
	};

	sendNewReport = async () => {
		// Wenn Meldung ohne Standort eingetragen werden soll -> Prüfen ob Responsible ausgewählt ist
		if (this.props.newReport.noLocation) {
			this.props.sendNewReport(this.props.newReport, this.props.reportsDefaultInvisible);
		} else {
			// Prüfen ob die angegebene Adresse gültig ist und Bestimmung der zugehörigen Koordinaten
			const latlng =
				this.state.activeTab === 'address' ? await this.getCoordinatesToAddress(this.props.newReport.address) : this.props.newReport.latlng;

			// Wenn latlng nicht gesetzt Funktion abbrechen und Fehlermeldung ausgeben, dass die angegebene Adresse ungültig ist
			if (!latlng) return this.props.showNewReportGetAddressError(this.props.intl.formatMessage({ id: 'newReport.send.addressError.text' }));

			// Prüfen ob die gewählte Position innerhalb des eigenen Zuständigkeitsbereich liegt
			if (this.checkResponsiblity({ latitude: latlng.lat, longitude: latlng.lng })) {
				this.props.sendNewReport({ ...this.props.newReport, latlng }, this.props.reportsDefaultInvisible);
			} else {
				swal({
					title: this.props.intl.formatMessage({ id: 'newReport.send.responsibilityError.title' }),
					text: this.props.intl.formatMessage({ id: 'newReport.send.responsibilityError.text' })
				});
			}
		}
	};

	onTypeChange = typeId => {
		// Kategorie vor dem Wechsel auslesen
		const previousType = this.props.types.find(t => t.id === this.props.newReport.typeId);
		// Kategorie updaten
		this.props.setNewReportPropValue({ typeId });
		const selectedType = this.props.types.find(t => t.id === typeId);
		// Wenn Kategorie interne Kategorie ist, Unsichtbarkeit aktivieren
		if (selectedType && selectedType.internalOnly)
			this.props.setNewReportPropValue({
				visible: false
			});
		// Wenn von interner auf normale Kategorie gewechselt wird, wird der ursprüngliche Sichtbarkeitsstatus wieder hergestellt
		if (previousType && previousType.internalOnly && selectedType && !selectedType.internalOnly)
			this.props.setNewReportPropValue({
				visible: this.state.oldVisibleStatus
			});
		// Ursprünglichen Unsichtbarkeitsstatus speichern wenn auf interne Kategorie gewechselt wird
		if (((previousType && !previousType.internalOnly) || !this.props.newReport.typeId) && selectedType && selectedType.internalOnly)
			this.setState({ oldVisibleStatus: this.props.newReport.visible });
	};

	renderTypes = types => {
		const internalTypes = types.filter(type => type.internalOnly);
		const publicTypes = types.filter(type => !type.internalOnly);

		return (
			<Fragment>
				{internalTypes.length > 0 && <option disabled>Interne Kategorien</option>}
				{internalTypes.map((type, index) => [
					type.superTypeId && (!internalTypes[index - 1] || internalTypes[index - 1].superTypeId !== type.superTypeId) && (
						<option key={type.superTypeName} disabled>
							&nbsp;Oberkategorie {type.superTypeName}
						</option>
					),
					type.superTypeId ? (
						<option key={type.id} value={type.id}>
							&nbsp;&nbsp;&nbsp;{type.name}
						</option>
					) : (
						<option key={type.id} value={type.id}>
							&nbsp;{type.name}
						</option>
					)
				])}
				{internalTypes.length > 0 && <option disabled>Öffentliche Kategorien</option>}
				{publicTypes.map((type, index) => [
					type.superTypeId && (!publicTypes[index - 1] || publicTypes[index - 1].superTypeId !== type.superTypeId) && (
						<option key={type.superTypeName} disabled>
							&nbsp;Oberkategorie {type.superTypeName}
						</option>
					),
					type.superTypeId ? (
						<option key={type.id} value={type.id}>
							&nbsp;&nbsp;&nbsp;{type.name}
						</option>
					) : (
						<option key={type.id} value={type.id}>
							&nbsp;{type.name}
						</option>
					)
				])}
			</Fragment>
		);
	};

	renderSidebar() {
		const {
			firstName,
			lastName,
			phone,
			email,
			latlng,
			address,
			typeId,
			description,
			images,
			title,
			responsibleId,
			noLocation,
			userComment,
			attachements,
			visible
		} = this.props.newReport;
		let dropzoneRef;
		const { setNewReportPropValue, removeNewReportImage, setNewReportAddressAttribute, resetNewReport } = this.props;

		const generalDataBlock = (
			<CardBox heading={<IntlMessages id="newReport.what" />} headerOutside styleName="col-12 p-0">
				<div className="row">
					<div className="col-md-6 col-sm-12">
						<div className="d-flex align-items-center mb-2">
							<ModulesContainer module="tickets" className="form-group mb-0">
								<div className="custom-control custom-checkbox mr-sm-2">
									<input
										type="checkbox"
										className="custom-control-input"
										id="noLocation"
										checked={noLocation}
										onChange={() =>
											setNewReportPropValue({
												noLocation: !noLocation
											})
										}
									/>
									<label className="custom-control-label mt-1" htmlFor="noLocation">
										<IntlMessages id="newReport.noLocation" />
									</label>
								</div>
							</ModulesContainer>
							<span
								className="ml-auto"
								title={this.props.intl.formatMessage({
									id: visible ? 'report.visibility.on' : 'report.visibility.off'
								})}
							>
								<Switch
									onChange={() =>
										setNewReportPropValue({
											visible: !visible
										})
									}
									checked={visible}
									checkedIcon={<i className="zmdi zmdi-eye zmdi-hc-fw switch-icon" />}
									uncheckedIcon={<i className="zmdi zmdi-eye-off zmdi-hc-fw switch-icon" />}
									onColor="#79b473"
								/>
							</span>
						</div>

						{noLocation && (
							<div className="form-group">
								<label>
									<IntlMessages id="report.props.responsible" /> (<IntlMessages id="common.mandatory" />)
								</label>
								<select
									className="custom-select mr-2 my-1 w-100"
									onChange={m =>
										setNewReportPropValue({
											responsibleId: parseInt(m.target.value)
										})
									}
									value={responsibleId}
								>
									<option value={0}>
										{this.props.intl.formatMessage({
											id: 'reportMap.filter.responsible.placeholder'
										})}
									</option>
									{this.props.responsibles.map(r => (
										<option key={r.responsibleId} value={r.responsibleId}>
											{r.name}
										</option>
									))}
								</select>
							</div>
						)}
						<div className="form-group">
							<label>
								<IntlMessages id="newReport.type.title" /> (<IntlMessages id="common.mandatory" />)
							</label>
							<select
								className="custom-select mr-2 my-1 w-100"
								onChange={m => this.onTypeChange(parseInt(m.target.value))}
								value={typeId}
							>
								<option value={0}>
									{this.props.intl.formatMessage({
										id: 'newReport.type.placeholder'
									})}
								</option>

								{this.renderTypes(this.props.types)}
							</select>
						</div>
						<div className="form-group">
							<label>
								<IntlMessages id="report.props.title" />
							</label>
							<input
								className="form-control form-control-lg"
								value={title}
								onChange={m =>
									setNewReportPropValue({
										title: m.target.value
									})
								}
								type="text"
								placeholder={this.props.intl.formatMessage({
									id: 'report.props.title'
								})}
								maxLength={InputSize.reportTitle}
							/>
						</div>
						<div className="form-group">
							<label>
								<IntlMessages id="newReport.description" />
							</label>
							<textarea
								className="form-control form-control-lg my-3"
								rows="3"
								placeholder={this.props.intl.formatMessage({
									id: 'newReport.description'
								})}
								onChange={m =>
									setNewReportPropValue({
										description: m.target.value
									})
								}
								value={description}
								maxLength={InputSize.reportDescription}
							/>
						</div>
					</div>
					<div className="col-md-6 col-sm-12">
						<div className="dropzone">
							<Dropzone
								ref={node => {
									dropzoneRef = node;
								}}
								onDrop={(accepted, rejected) =>
									setNewReportPropValue({
										images: [...images, ...accepted]
									})
								}
								multiple={false}
								disableClick={true}
								accept="image/png, image/gif, image/jpeg"
							>
								{images.length === 0 ? (
									<div
										className="w-100 h-100 d-flex align-items-center flex-column"
										style={{
											justifyContent: 'space-evenly'
										}}
									>
										<i
											className="zmdi zmdi-collection-image-o zmdi-hc"
											style={{
												fontSize: '5em'
											}}
										/>
										<p className="pt-2 text-center">
											<IntlMessages id="userProfile.profileImage.dropImage" />
										</p>
									</div>
								) : (
									<div className="gl-image w-100 h-100">
										<div className="gl row no-gutters g-ul w-100">
											{images.map((image, index) => (
												<div key={index} className="col-6">
													<div
														className="grid w-100"
														style={{
															height: 79,
															backgroundImage: `url(${image.preview})`,
															backgroundSize: 'cover',
															backgroundRepeat: 'no-repeat',
															backgroundPosition: 'center'
														}}
													/>
													<div className="diagonal-box" />
													<div
														className="image-remove-icon d-flex align-items-end justify-content-end pointer"
														onClick={() => removeNewReportImage(index)}
													>
														<i className="zmdi zmdi-close zmdi-hc-2x" />
													</div>
												</div>
											))}
											{images.length < 4 ? (
												<div className="col-6">
													<div
														className="grid w-100 d-flex align-items-center justify-content-center"
														style={{
															height: 79,
															backgroundColor: '#f4f4f4'
														}}
														onClick={() => {
															dropzoneRef.open();
														}}
													>
														<i className="zmdi zmdi-plus zmdi-hc-2x" />
													</div>
												</div>
											) : null}
										</div>
									</div>
								)}
							</Dropzone>
							<p className="text-muted text-center m-2">
								<IntlMessages id="common.or" />
							</p>
							<div className="d-flex flex-direction-column align-items-center px-3 py-0">
								<Button
									color="default"
									className="jr-btn btn-blue btn border-0 mt-0 mb-2 mx-0"
									onClick={() => {
										dropzoneRef.open();
									}}
									disabled={images.length > 3}
									style={{ width: 200 }}
								>
									<IntlMessages id="userProfile.profileImage.selectImage" />
								</Button>
							</div>
						</div>
					</div>
				</div>
			</CardBox>
		);

		const locationBlock = (
			<CardBox heading={<IntlMessages id="newReport.where" />} headerOutside cardStyle="p-0 border-0" styleName="col-12 p-0">
				<Card>
					<CardHeader className="bg-primary">
						<Nav className="nav-fill card-header-tabs" tabs>
							<NavItem>
								<NavLink
									className={this.state.activeTab === 'address' ? 'active' : ''}
									onClick={() => {
										this.toggle('address');
									}}
								>
									<i className="zmdi zmdi-format-subject mr-2" />
									<IntlMessages id="newReport.address.title" />
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={this.state.activeTab === 'map' ? 'active' : ''}
									onClick={() => {
										this.toggle('map');
									}}
								>
									<i className="zmdi zmdi-gps mr-2" />
									<IntlMessages id="newReport.location.title" />
								</NavLink>
							</NavItem>
						</Nav>
					</CardHeader>

					<TabContent activeTab={this.state.activeTab}>
						<TabPane tabId="address">
							<CardBody>
								<div className="row">
									<div className="col-sm-6 col-12">
										<div className="form-group">
											<label>
												<IntlMessages id="report.props.address.zip" />
											</label>
											<input
												className="form-control form-control-lg"
												value={address.zip}
												onChange={m =>
													setNewReportAddressAttribute({
														zip: m.target.value
													})
												}
												type="text"
												placeholder={this.props.intl.formatMessage({
													id: 'report.props.address.zip'
												})}
												maxLength={InputSize.addressZip}
											/>
										</div>
									</div>

									<div className="col-sm-6 col-12">
										<div className="form-group">
											<label>
												<IntlMessages id="report.props.address.city" />
											</label>
											<input
												className="form-control form-control-lg"
												value={address.city}
												onChange={m =>
													setNewReportAddressAttribute({
														city: m.target.value
													})
												}
												type="text"
												placeholder={this.props.intl.formatMessage({
													id: 'report.props.address.city'
												})}
												maxLength={InputSize.addressCity}
											/>
										</div>
									</div>

									<div className="col-sm-6 col-12">
										<div className="form-group">
											<label>
												<IntlMessages id="report.props.address.street" />
											</label>
											<input
												className="form-control form-control-lg"
												value={address.street}
												onChange={m =>
													setNewReportAddressAttribute({
														street: m.target.value
													})
												}
												type="text"
												placeholder={this.props.intl.formatMessage({
													id: 'report.props.address.street'
												})}
												maxLength={InputSize.addressStreet}
											/>
										</div>
									</div>

									<div className="col-sm-6 col-12">
										<div className="form-group">
											<label>
												<IntlMessages id="common.houseNumber" />
											</label>
											<input
												className="form-control form-control-lg"
												value={address.houseNumber}
												onChange={m =>
													setNewReportAddressAttribute({
														houseNumber: m.target.value
													})
												}
												type="text"
												placeholder={this.props.intl.formatMessage({
													id: 'common.houseNumber'
												})}
												maxLength={InputSize.addressHouseNumber}
											/>
										</div>
									</div>
								</div>
							</CardBody>
						</TabPane>
						<TabPane tabId="map">
							<CardBody className="p-0">
								<div className="embed-responsive embed-responsive-4by3">
									<div className="embed-responsive-item">
										<Map
											onSelectLocation={this.onSelectLocation}
											selectedLocation={latlng}
											mapCenter={this.props.organisationLatlng}
											address={address}
											addressToLocationLoading={this.props.loading.addressToLocation}
											responsibilityAreas={this.props.responsibilityAreas.map(area => {
												return {
													...area,
													paths: area.paths.map(path =>
														path.map(coordinates => {
															return {
																lat: coordinates[0],
																lng: coordinates[1]
															};
														})
													)
												};
											})}
											layers={
												this.props.showLayers
													? [
															{
																baseUrl:
																	'https://geoportal.detmold.de/cgi-bin/UMNMapserver620/mapserv.exe?map=d:/geodaten/system/UMNFiles/mapfiles/620/Gruenanlagen_oeffentl.map&',
																layers: 'Gruenanlagen',
																title: 'Grünanlagen'
															},
															{
																baseUrl:
																	'https://geoportal.detmold.de/cgi-bin/UMNMapserver620/mapserv.exe?map=d:/geodaten/system/UMNFiles/mapfiles/620/Leuchtstellen.map&',
																layers: 'Schaltschraenke_P,Leuchtstellen_P',
																title: 'Leuchtstellen'
															},
															{
																baseUrl:
																	'https://geoportal.detmold.de/qgis/qgis_mapserv.fcgi.exe?MAP=d:/geodaten/qgis/P_130_Kanalbestand.qgs&',
																layers: 'Haltungen,Schaechte,Druckentwaesserung',
																title: 'Kanal'
															},
															{
																baseUrl:
																	'https://geoportal.detmold.de/cgi-bin/UMNMapserver620/mapserv.exe?map=d:/geodaten/system/UMNFiles/mapfiles/620/baumkataster.map&',
																layers: 'Baum,Baumkrone',
																title: 'Baum'
															},
															{
																baseUrl: 'https://www.wms.nrw.de/umwelt/linfos?SERVICE=WMS&',
																layers: 'geschuetzteBiotope,Naturschutzgebiete,Alleen-Kataster',
																title: 'Schutzgebiete'
															},
															{
																baseUrl:
																	'https://geoportal.detmold.de/cgi-bin/UMNMapserver620/mapserv.exe?map=d:/geodaten/system/UMNFiles/mapfiles/620/strassenkataster_oeffentl.map&',
																layers: 'gcsib_strasse_p,gcsib_strasse_l,gcsib_strasse_pl',
																title: 'Straße'
															},
															{
																baseUrl:
																	'https://geoportal.detmold.de/cgi-bin/UMNMapserver620/mapserv.exe?map=d:/geodaten/system/UMNFiles/mapfiles/620/eigentum_stadt_oeffentl.map&',
																layers: 'Eigentum_Detmold',
																title: 'Öffentliches Eigentum'
															}
													  ]
													: null
											}
										/>
									</div>
								</div>
							</CardBody>
						</TabPane>
					</TabContent>
				</Card>
			</CardBox>
		);

		const contactDataBlock = (
			<CardBox heading={<IntlMessages id="newReport.who" />} headerOutside styleName="col-12 p-0">
				<div className="row">
					<div className="col-sm-6 col-12">
						<div className="form-group">
							<label>
								<IntlMessages id="newReport.citizen.name" />
							</label>
							<input
								className="form-control form-control-lg"
								value={firstName}
								onChange={m =>
									setNewReportPropValue({
										firstName: m.target.value
									})
								}
								type="text"
								placeholder={this.props.intl.formatMessage({
									id: 'newReport.citizen.firstName'
								})}
								maxLength={InputSize.userFirstName}
							/>
						</div>
					</div>

					<div className="col-sm-6 col-12">
						<div className="form-group">
							<label>&nbsp;</label>
							<input
								className="form-control form-control-lg"
								value={lastName}
								onChange={m =>
									setNewReportPropValue({
										lastName: m.target.value
									})
								}
								type="text"
								placeholder={this.props.intl.formatMessage({
									id: 'newReport.citizen.lastName'
								})}
								maxLength={InputSize.userLastName}
							/>
						</div>
					</div>

					<div className="col-sm-6 col-12">
						<div className="form-group">
							<label>
								<IntlMessages id="newReport.citizen.email" />
							</label>
							<input
								className="form-control form-control-lg"
								value={email}
								onChange={m =>
									setNewReportPropValue({
										email: m.target.value
									})
								}
								type="email"
								placeholder={this.props.intl.formatMessage({
									id: 'newReport.citizen.email'
								})}
								maxLength={InputSize.userEmail}
							/>
						</div>
					</div>

					<div className="col-sm-6 col-12">
						<div className="form-group">
							<label>
								<IntlMessages id="newReport.citizen.phone" />
							</label>
							<input
								className="form-control form-control-lg"
								value={phone}
								onChange={m =>
									setNewReportPropValue({
										phone: m.target.value
									})
								}
								type="tel"
								placeholder={this.props.intl.formatMessage({
									id: 'newReport.citizen.phone'
								})}
								maxLength={InputSize.userPhone}
							/>
						</div>
					</div>
				</div>
			</CardBox>
		);

		const commentBlock = (
			<ModulesContainer module="tickets">
				<CardBox heading={<IntlMessages id="newReport.attachements" />} headerOutside styleName="col-12 p-0">
					<div className="row">
						<div className="col-md-6 col-sm-12">
							<div className="w-100">
								<h4>{this.props.intl.formatMessage({ id: 'newReport.attachements.comment' })}</h4>
								<div className="form-group my-0">
									<textarea
										maxLength={1000}
										className="form-control form-control-lg my-0"
										rows="8"
										placeholder={this.props.intl.formatMessage({
											id: 'report.userComments.placeholder'
										})}
										onChange={m =>
											setNewReportPropValue({
												userComment: m.target.value
											})
										}
										value={userComment}
									/>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-sm-12">
							<div className="w-100">
								<h4>{this.props.intl.formatMessage({ id: 'newReport.attachements.files' })}</h4>
								<div className="dropzone">
									<Dropzone
										ref={node => {
											this.attachementsRef = node;
										}}
										onDrop={(accepted, rejected) => (accepted && accepted[0] ? this.handleFileDrop(accepted[0]) : null)}
										multiple={false}
										disableClick={true}
									>
										<div
											className="w-100 h-100 d-flex align-items-center flex-column"
											style={{
												justifyContent: 'space-evenly'
											}}
										>
											<i
												className="zmdi zmdi-file-plus zmdi-hc"
												style={{
													fontSize: '5em'
												}}
											/>
											<p className="pt-2 text-center">
												<IntlMessages id="newReport.attachements.fileDrop" />
											</p>
										</div>
									</Dropzone>
									<p className="text-muted text-center m-2">
										<IntlMessages id="common.or" />
									</p>
									<div className="d-flex flex-direction-column align-items-center px-3 py-0">
										<Button
											color="default"
											className="jr-btn btn-blue btn border-0 mt-0 mb-2 mx-0"
											onClick={() => {
												this.attachementsRef.open();
											}}
											style={{ width: 200 }}
										>
											<IntlMessages id="newReport.attachements.file" />
										</Button>
									</div>
								</div>
								<ListGroup>
									{attachements.map((a, i) => (
										<ListGroupItem key={i} action className="d-flex align-items-center list-group-item">
											<span className="text-dark">{`${a.fileName} (${byteStr(a.file.size)})`}</span>
											<span
												className="ml-auto pointer"
												style={{ width: 10 }}
												onClick={() =>
													setNewReportPropValue({
														attachements: attachements.filter((element, index) => index !== i)
													})
												}
											>
												<i className="zmdi zmdi-hc-lg zmdi-close ml-auto text-dark" />
											</span>
										</ListGroupItem>
									))}
								</ListGroup>
							</div>
						</div>
					</div>
				</CardBox>
			</ModulesContainer>
		);

		const showContent = () =>
			!noLocation ? (
				<Fragment>
					<div className="col-lg-6 col-md-12">
						{generalDataBlock}
						{contactDataBlock}
					</div>

					<div className="col-lg-6 col-md-12">
						{locationBlock}
						{commentBlock}
					</div>
				</Fragment>
			) : (
				<Fragment>
					<div className="col-lg-6 col-md-12">{generalDataBlock}</div>
					<div className="col-lg-6 col-md-12">
						{contactDataBlock}
						{commentBlock}
					</div>
				</Fragment>
			);

		return (
			<div
				className="app-wrapper"
				style={{
					backgroundColor: '#f4f4f4',
					maxHeight: '100vh',
					overflowY: 'scroll'
				}}
			>
				<div className="d-flex">
					<h2 className="title mb-3">Neue Meldung erstellen</h2>
					<Button
						color="default"
						className="jr-flat-btn jr-btn ml-auto my-0 px-0"
						onClick={() => this.props.setNewReportDrawerState(false)}
					>
						<i className="zmdi zmdi-close zmdi-hc-lg" />
						<IntlMessages id="common.close" />
					</Button>
				</div>
				<div className="row">
					{showContent()}
					<div className="col-12 d-flex">
						<Button
							color="default"
							className="jr-btn btn-blue btn border-0 mt-0 mb-2"
							onClick={this.sendNewReport}
							disabled={
								this.props.loading.sendNewReport ||
								!typeId ||
								(noLocation && !responsibleId) ||
								(!noLocation && this.state.activeTab === 'map' && (!latlng.lat || !latlng.lng))
							}
						>
							{this.props.loading.sendNewReport ? (
								<i className="zmdi zmdi-spinner zmdi-hc-spin" />
							) : (
								<IntlMessages id="newReport.send" />
							)}
						</Button>
						<Button
							color="default"
							className="jr-btn btn-grey btn border-0 mt-0 mb-2"
							onClick={() => resetNewReport(this.props.reportsDefaultInvisible)}
						>
							<IntlMessages id="newReport.reset" />
						</Button>
					</div>
				</div>
			</div>
		);
	}

	render() {
		const { setNewReportDrawerState, showDrawer } = this.props;
		return (
			<div className="drawer-box">
				<Drawer
					sidebar={this.renderSidebar()}
					position="top"
					touch
					open={showDrawer}
					onOpenChange={() => setNewReportDrawerState(!showDrawer)}
					style={{ overflow: 'auto' }}
				>
					<div />
				</Drawer>
			</div>
		);
	}
}

function mapStateToProps({ newReport, accountSettings, auth }) {
	return {
		newReport: newReport.newReport,
		showDrawer: newReport.showDrawer,
		types: _.orderBy(_.uniqWith(accountSettings.areaTypes, _.isEqual).filter(e => !isIssue(e.id)), ['superTypeName', 'name']),
		organisationLatlng: accountSettings.organisationStructure.location.latlng,
		responsibilityAreas: accountSettings.organisationStructure.responsibilityAreas,
		responsibles: [
			...accountSettings.organisationStructure.groups.filter(group => group.modules.reports),
			...accountSettings.organisationStructure.users
				.filter(user => user.modules.reports)
				.map(u => {
					return { responsibleId: u.responsibleId, name: `${u.firstName} ${u.lastName}` };
				})
		],
		loading: newReport.loading,
		authUser: auth.authUser,
		reportsDefaultInvisible: accountSettings.organisationStructure.reportsDefaultInvisible,
		showLayers: accountSettings.organisationStructure.organisationId === 4942
	};
}

NewReport.propTypes = {
	intl: intlShape
};

export default connect(
	mapStateToProps,
	{
		setNewReportDrawerState,
		setNewReportPropValue,
		removeNewReportImage,
		setNewReportAddressAttribute,
		setNewReportLocation,
		resetNewReport,
		sendNewReport,
		showNewReportGetAddressError
	}
)(injectIntl(NewReport));



// WEBPACK FOOTER //
// ./containers/NewReport/index.js